import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerDistrictAll: [],
  insurerDistrict: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerDistrictSlice = createSlice({
  name: "insurerDistrict",
  initialState,
  reducers: {
    setInsurerDistrictAll: (state, action) => {
      state.insurerDistrictAll = action.payload;
    },
    setInsurerDistrict: (state, action) => {
      state.insurerDistrict = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerDistrictAll,
  setInsurerDistrict,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerDistrictSlice.actions;

export default insurerDistrictSlice.reducer;
